import type { Room, RoomFinishSettings } from "../types";

export type FinishUndoSurface = "floor" | "walls" | "ceiling" | "wall" | "trim" | "look" | "setting";

const same = (a: unknown, b: unknown) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

const FIELDS: [keyof RoomFinishSettings, FinishUndoSurface][] = [
  ["floor", "floor"],
  ["walls", "walls"],
  ["ceiling", "ceiling"],
  ["wallOverrides", "wall"],
  ["trimColor", "trim"],
];

/**
 * Which finish an undo / redo step changed, or null when it wasn't a finish
 * change (any geometry change counts as a room edit, even if it carried
 * per-wall finishes along).
 */
export function finishUndoSurface(before: Room, after: Room): FinishUndoSurface | null {
  const { finishes: a, ...restA } = before;
  const { finishes: b, ...restB } = after;
  if (same(a, b) || !same(restA, restB)) return null;
  const fa = a ?? {};
  const fb = b ?? {};
  if (!same(fa.setting, fb.setting)) return "setting";
  const changed = FIELDS.filter(([k]) => !same(fa[k], fb[k])).map(([, s]) => s);
  if (changed.length !== 1 && !same(fa.look, fb.look)) return "look";
  return changed[0] ?? "look";
}
